"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                KpiTile_Status: "Status",
                KpiTile_Trend: "Trend",
                KpiTile_Value: "Value",
            }
        });
        /**
         * Extends the Tile control to display aggregate measures.
         * @param data Context provided when created the control.
         */
        var KPITile = /** @class */ (function (_super) {
            __extends(KPITile, _super);
            function KPITile(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.updateKpiFromJson = function (kpiValues) {
                    var parsedKpiStructure;
                    if (!kpiValues) {
                        $dyn.logWarning("kpiValues cannot be null or undefined.");
                        return;
                    }
                    if (!$.isPlainObject(kpiValues)) {
                        parsedKpiStructure = JSON.parse(kpiValues);
                    }
                    else {
                        parsedKpiStructure = kpiValues;
                    }
                    _this.KpiValid(parsedKpiStructure.IsValid === 1);
                    if (parsedKpiStructure.IsValid === 1) {
                        _this.KpiStatus(parsedKpiStructure.Status);
                        _this.KpiTrend(parsedKpiStructure.Trend);
                        _this.KpiValueType(parsedKpiStructure.ValueType);
                        _this.KpiValue(parsedKpiStructure.Value);
                        _this.HasKpiTrendInfo(parsedKpiStructure.HasTrendInfo === 1);
                        _this.ShowStatus(parsedKpiStructure.ShowStatus);
                        _this.ShowTrend(parsedKpiStructure.ShowTrend);
                        _this.ShowGoal(parsedKpiStructure.ShowGoal);
                        _this.ThresholdType(parsedKpiStructure.ThresholdType);
                        _this.ThresholdDisplayName(parsedKpiStructure.ThresholdDisplayName);
                        _this.ThresholdSign(parsedKpiStructure.ThresholdSign);
                        _this.PercentageChange(parsedKpiStructure.PercentageChange);
                        if ($dyn.value(_this.ThresholdType) === "Percentage") {
                            _this.PercentageChange($dyn.value(_this.ThresholdSign) + $dyn.value(_this.PercentageChange) + "%");
                        }
                        else {
                            var formattedPercetageChange = _this.formatKpiValue($dyn.value(_this.PercentageChange));
                            _this.PercentageChange($dyn.value(_this.ThresholdSign) + formattedPercetageChange.valueText + formattedPercetageChange.magnitudeIndicator);
                        }
                        var strValue = "";
                        var value_1 = parseFloat(_this.KpiValue());
                        if (isNaN(value_1)) {
                            strValue = _this.KpiValue();
                        }
                        else {
                            strValue = Globalize.format(($dyn.value(_this.KpiValueType) === "Percentage") ? value_1 / 100 : value_1, _this.kpiValueFormat(), Globalize.culture().language);
                        }
                        // update title
                        var title = $dyn.format("{0}\n{1}: {2}\n{3}: {4}", $dyn.value(_this.Label), $dyn.label("KpiTile_Value"), strValue, $dyn.label("KpiTile_Status"), _this.KpiStatus());
                        if (_this.HasKpiTrendInfo()) {
                            title = $dyn.format("{0}\n{1}: {2}", title, $dyn.label("KpiTile_Trend"), _this.KpiTrend);
                        }
                        _this.TileTitle(title);
                    }
                };
                /** If the tile name changes, requery for the appropriate data. */
                _this.KpiNameChanged = function () {
                    _this.requestTileData();
                };
                _this.tileRefresh = function (newVal) {
                    if (newVal) {
                        $dyn.log("Tiles: tileRefresh");
                        _this.requestTileData();
                    }
                };
                _this.hasCountAndImage = $dyn.computed(function () {
                    var buttonDisplay = _this.buttonDisplay;
                    var imageName = $dyn.value(_this.ImageName);
                    var imageType = $dyn.value(_this.ImageType);
                    if (buttonDisplay !== $dyn.ui.ButtonDisplay.textOnly
                        && (buttonDisplay !== $dyn.ui.ButtonDisplay.backgroundImage || (buttonDisplay === $dyn.ui.ButtonDisplay.backgroundImage && imageType === "Symbol"))
                        && imageName) {
                        return true;
                    }
                });
                _this.initTile();
                return _this;
            }
            KPITile.prototype.requestTileData = function () {
                $dyn.applyFunction(this.GetTileData, this);
            };
            KPITile.prototype.kpiValueFormat = function () {
                var formatParameter = "";
                switch ($dyn.value(this.KpiValueType)) {
                    case "Currency":
                        formatParameter = "c";
                        break;
                    case "Percentage":
                        formatParameter = "p";
                        break;
                    case "Integer":
                        formatParameter = "n0";
                        break;
                    case "Real":
                    default:
                        formatParameter = "n";
                        break;
                }
                return formatParameter;
            };
            KPITile.prototype.formatKpiValue = function (kpiValue) {
                var summaryValueText;
                var value = parseFloat(kpiValue);
                if (isNaN(value)) {
                    value = 0;
                }
                var roundedValue = Math.round(value * 100) / 100;
                var numberOfWholeDigits = this.determineWholeNumberDigits(roundedValue);
                var remainingDigits = numberOfWholeDigits;
                var indicatorIndex = 0;
                var groupSize = this.determineNextCultureGroupSize(indicatorIndex);
                while (remainingDigits > groupSize) {
                    indicatorIndex++;
                    remainingDigits -= groupSize;
                    groupSize = this.determineNextCultureGroupSize(indicatorIndex);
                }
                if (numberOfWholeDigits > groupSize) {
                    var lengthOfNumber = remainingDigits + 1;
                    var digitsToRemove = numberOfWholeDigits - lengthOfNumber;
                    for (var iDigit = 0; iDigit < digitsToRemove; iDigit++) {
                        roundedValue /= 10;
                    }
                    roundedValue = Math.round(roundedValue * 100) / 100;
                    roundedValue /= 10;
                    if (this.determineWholeNumberDigits(roundedValue) > groupSize) {
                        indicatorIndex++;
                        for (var iGroup = 0; iGroup < groupSize; iGroup++) {
                            roundedValue /= 10;
                        }
                        roundedValue *= 10;
                        roundedValue = Math.round(roundedValue);
                        roundedValue /= 10;
                    }
                    summaryValueText = Globalize.format((($dyn.value(this.KpiValueType) === "Percentage") ? roundedValue / 100
                        : roundedValue), this.kpiValueFormat() + 2, Globalize.culture().language);
                }
                else {
                    value *= 100;
                    value = Math.round(value);
                    value /= 100;
                    summaryValueText = Globalize.format((($dyn.value(this.KpiValueType) === "Percentage") ? value / 100 : value), this.kpiValueFormat(), Globalize.culture().language);
                }
                var magnitudeIndicator = this.getMagnitudeIndicator(indicatorIndex);
                if ($dyn.value(this.KpiValueType) === "Percentage") {
                    summaryValueText = summaryValueText.toString();
                }
                return { valueText: summaryValueText, magnitudeIndicator: magnitudeIndicator };
            };
            KPITile.prototype.determineWholeNumberDigits = function (value) {
                var wholeValue = Math.floor(Math.abs(value));
                var count = 0;
                while (wholeValue > 0) {
                    wholeValue = Math.floor(wholeValue / 10);
                    count++;
                }
                return count;
            };
            KPITile.prototype.determineNextCultureGroupSize = function (index) {
                var groupSizes = Globalize.culture().numberFormat.groupSizes;
                var groupSizesLength = groupSizes.length;
                var groupSize;
                if (index >= groupSizesLength) {
                    groupSize = groupSizes[groupSizesLength - 1];
                }
                else {
                    groupSize = groupSizes[index];
                }
                return groupSize;
            };
            KPITile.prototype.getMagnitudeIndicator = function (indicatorIndex) {
                var magnitudeIndicator;
                switch (indicatorIndex) {
                    case 0:
                        magnitudeIndicator = " ";
                        break;
                    case 1:
                        magnitudeIndicator = "K";
                        break;
                    case 2:
                        magnitudeIndicator = "M";
                        break;
                    case 3:
                        magnitudeIndicator = "B";
                        break;
                    case 4:
                        magnitudeIndicator = "T";
                        break;
                    case 5:
                        magnitudeIndicator = "Q";
                        break;
                    default:
                        magnitudeIndicator = "ER";
                        break;
                }
                return magnitudeIndicator;
            };
            KPITile.prototype.initTile = function () {
                var _this = this;
                this.KpiStatus = $dyn.observable("");
                this.KpiTrend = $dyn.observable("");
                this.KpiValue = $dyn.observable("--"); // externally set value
                this.kpiValue = $dyn.observable("--"); // displayed value
                this.KpiValid = $dyn.observable(false);
                this.KpiValueType = $dyn.observable("");
                this.KpiMagnitude = $dyn.observable("");
                this.HasKpiTrendInfo = $dyn.observable();
                this.ShowStatus = $dyn.observable("");
                this.ShowTrend = $dyn.observable("");
                this.ShowGoal = $dyn.observable("");
                this.PercentageChange = $dyn.observable("");
                this.ThresholdType = $dyn.observable("");
                this.ThresholdDisplayName = $dyn.observable("");
                this.ThresholdSign = $dyn.observable("");
                $dyn.observe(this.KpiValue, function (value) {
                    var formattedValue = _this.formatKpiValue(value);
                    _this.kpiValue(formattedValue.valueText);
                    _this.KpiMagnitude(formattedValue.magnitudeIndicator);
                });
                if (this.KpiName) {
                    this.requestTileData();
                }
                if ($dyn.value(this.Refreshing) !== null) {
                    // If a refresh observable was specified, observe that and trigger an update when true
                    $dyn.observe(this.Refreshing, this.tileRefresh);
                }
                else if (this.Root && this.Root.Refreshing) {
                    // Otherwise if a root form is available, observe the form"s Refreshing property and trigger an update when true
                    $dyn.observe(this.Root.Refreshing, this.tileRefresh);
                }
                this.KpiValid(false);
                this.HasKpiTrendInfo(false);
                this.KpiValue("--");
            };
            return KPITile;
        }($dyn.controls.Tile));
        controls.KPITile = KPITile;
        $dyn.ui.addPropertiesToPrototype(KPITile.prototype, {
            KpiName: { defaultValue: undefined, observable: false },
        });
        $dyn.ui.addObservablePropertiesToPrototype(controls.CountTile.prototype, {
            Count: "--",
            Refreshing: null
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=KPITile.js.map
